import {useMutation} from "@tanstack/react-query";
import {useModal} from "../../../../hooks";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import {exportProjectExcelApi} from "../../../../api/correspondent/projectApi";
import {downloadFile} from "../../../../util/FileDownload";
import moment from "moment";
import {AxiosError} from "axios";

export const useExportProjectExcel = () => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: AccountSearchInterface) => exportProjectExcelApi(data),
        onSuccess: (res) => {
            if (res instanceof Blob) {
                downloadFile(
                    res,
                    `프로젝트_목록_${moment(new Date()).format("YYYY_MM_DD")}.xlsx`
                );
            }
        },
        onError: (error: AxiosError) => {
            console.log(error);
            if (error?.response?.data instanceof Blob) {
                error.response.data.text().then((value) => {
                    const obj = JSON.parse(value);
                    handleModal({
                        isOpen: true,
                        contents: obj?.msg,
                        type: "alert",
                    });
                });
            }
        },
    });

    return {mutate};
};
